export const ADD_ONS_API_REDUCER_PATH = 'addOnsApi';
